<template>
  <BreadCrumb PageTitle="Liste des virements" />
  <VirementList />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import VirementList from "@/components/Virements/VirementList.vue";

export default defineComponent({
  name: "VirementListPage",
  components: {
    BreadCrumb,
    VirementList,
  },
});
</script>